import { IPoi } from '../poi-model/poi';
import { IPoiPresenter } from './presenter-factory';

export abstract class PresenterBase implements IPoiPresenter {

  getShortAddress(poi: IPoi): string | undefined {
    const address = poi.getAddress();
    return address.shortFormattedAddress.get() || address.formattedAddress.get();
  }
}